import { each as ge, useIsomorphicLayoutEffect as an } from "@react-spring/shared";
import { is as K, toArray as $t, eachProp as dt, getFluidValue as Zt, isAnimatedString as en, Globals as tn } from "@react-spring/shared";
function I(t) {
  for (var _len = arguments.length, e = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    e[_key - 1] = arguments[_key];
  }
  return K.fun(t) ? t(...e) : t;
}
var te = (t, e) => t === !0 || !!(e && t && (K.fun(t) ? t(e) : $t(t).includes(e))),
  et = (t, e) => K.obj(t) ? e && t[e] : t;
var ke = (t, e) => t.default === !0 ? t[e] : t.default ? t.default[e] : void 0,
  nn = t => t,
  ne = function (t) {
    let e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : nn;
    let n = rn;
    t.default && t.default !== !0 && (t = t.default, n = Object.keys(t));
    let r = {};
    for (let o of n) {
      let s = e(t[o], o);
      K.und(s) || (r[o] = s);
    }
    return r;
  },
  rn = ["config", "onProps", "onStart", "onChange", "onPause", "onResume", "onRest"],
  on = {
    config: 1,
    from: 1,
    to: 1,
    ref: 1,
    loop: 1,
    reset: 1,
    pause: 1,
    cancel: 1,
    reverse: 1,
    immediate: 1,
    default: 1,
    delay: 1,
    onProps: 1,
    onStart: 1,
    onChange: 1,
    onPause: 1,
    onResume: 1,
    onRest: 1,
    onResolve: 1,
    items: 1,
    trail: 1,
    sort: 1,
    expires: 1,
    initial: 1,
    enter: 1,
    update: 1,
    leave: 1,
    children: 1,
    onDestroyed: 1,
    keys: 1,
    callId: 1,
    parentId: 1
  };
function sn(t) {
  let e = {},
    n = 0;
  if (dt(t, (r, o) => {
    on[o] || (e[o] = r, n++);
  }), n) return e;
}
function de(t) {
  let e = sn(t);
  if (e) {
    let n = {
      to: e
    };
    return dt(t, (r, o) => o in e || (n[o] = r)), n;
  }
  return {
    ...t
  };
}
function me(t) {
  return t = Zt(t), K.arr(t) ? t.map(me) : en(t) ? tn.createStringInterpolator({
    range: [0, 1],
    output: [t, t]
  })(1) : t;
}
function Ue(t) {
  for (let e in t) return !0;
  return !1;
}
function Ee(t) {
  return K.fun(t) || K.arr(t) && K.obj(t[0]);
}
function xe(t, e) {
  t.ref?.delete(t), e?.delete(t);
}
function he(t, e) {
  e && t.ref !== e && (t.ref?.delete(t), e.add(t), t.ref = e);
}
function wr(t, e) {
  let n = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 1e3;
  an(() => {
    if (e) {
      let r = 0;
      ge(t, (o, s) => {
        let i = o.current;
        if (i.length) {
          let a = n * e[s];
          isNaN(a) ? a = r : r = a, ge(i, u => {
            ge(u.queue, p => {
              let f = p.delay;
              p.delay = d => a + I(f || 0, d);
            });
          }), o.start();
        }
      });
    } else {
      let r = Promise.resolve();
      ge(t, o => {
        let s = o.current;
        if (s.length) {
          let i = s.map(a => {
            let u = a.queue;
            return a.queue = [], u;
          });
          r = r.then(() => (ge(s, (a, u) => ge(i[u] || [], p => a.queue.push(p))), Promise.all(o.start())));
        }
      });
    }
  });
}
import { is as Qn } from "@react-spring/shared";
import { useContext as Mn, useMemo as Xe, useRef as Nt } from "react";
import { is as jn, each as Ye, usePrev as Dt, useOnce as Nn, useForceUpdate as Dn, useIsomorphicLayoutEffect as qn } from "@react-spring/shared";
import { is as R, raf as ve, each as At, isEqual as Y, toArray as Rt, eachProp as Pn, frameLoop as Tn, flushCalls as Qe, getFluidValue as ie, isAnimatedString as xn, Globals as bn, callFluidObservers as An, hasFluidValue as Se, addFluidObserver as Rn, removeFluidObserver as vn, getFluidObservers as vt } from "@react-spring/shared";
import { AnimatedValue as Cn, AnimatedString as Ct, getPayload as In, getAnimated as ae, setAnimated as Vn, getAnimatedType as It } from "@react-spring/animated";
import { is as re, easings as un } from "@react-spring/shared";
var mt = {
  default: {
    tension: 170,
    friction: 26
  },
  gentle: {
    tension: 120,
    friction: 14
  },
  wobbly: {
    tension: 180,
    friction: 12
  },
  stiff: {
    tension: 210,
    friction: 20
  },
  slow: {
    tension: 280,
    friction: 60
  },
  molasses: {
    tension: 280,
    friction: 120
  }
};
var tt = {
    ...mt.default,
    mass: 1,
    damping: 1,
    easing: un.linear,
    clamp: !1
  },
  we = class {
    tension;
    friction;
    frequency;
    damping;
    mass;
    velocity = 0;
    restVelocity;
    precision;
    progress;
    duration;
    easing;
    clamp;
    bounce;
    decay;
    round;
    constructor() {
      Object.assign(this, tt);
    }
  };
function gt(t, e, n) {
  n && (n = {
    ...n
  }, ht(n, e), e = {
    ...n,
    ...e
  }), ht(t, e), Object.assign(t, e);
  for (let i in tt) t[i] == null && (t[i] = tt[i]);
  let {
      frequency: r,
      damping: o
    } = t,
    {
      mass: s
    } = t;
  return re.und(r) || (r < .01 && (r = .01), o < 0 && (o = 0), t.tension = Math.pow(2 * Math.PI / r, 2) * s, t.friction = 4 * Math.PI * o * s / r), t;
}
function ht(t, e) {
  if (!re.und(e.decay)) t.duration = void 0;else {
    let n = !re.und(e.tension) || !re.und(e.friction);
    (n || !re.und(e.frequency) || !re.und(e.damping) || !re.und(e.mass)) && (t.duration = void 0, t.decay = void 0), n && (t.frequency = void 0);
  }
}
var yt = [],
  Le = class {
    changed = !1;
    values = yt;
    toValues = null;
    fromValues = yt;
    to;
    from;
    config = new we();
    immediate = !1;
  };
import { is as pn, raf as St, Globals as ln } from "@react-spring/shared";
function Me(t, _ref) {
  let {
    key: e,
    props: n,
    defaultProps: r,
    state: o,
    actions: s
  } = _ref;
  return new Promise((i, a) => {
    let u,
      p,
      f = te(n.cancel ?? r?.cancel, e);
    if (f) b();else {
      pn.und(n.pause) || (o.paused = te(n.pause, e));
      let c = r?.pause;
      c !== !0 && (c = o.paused || te(c, e)), u = I(n.delay || 0, e), c ? (o.resumeQueue.add(m), s.pause()) : (s.resume(), m());
    }
    function d() {
      o.resumeQueue.add(m), o.timeouts.delete(p), p.cancel(), u = p.time - St.now();
    }
    function m() {
      u > 0 && !ln.skipAnimation ? (o.delayed = !0, p = St.setTimeout(b, u), o.pauseQueue.add(d), o.timeouts.add(p)) : b();
    }
    function b() {
      o.delayed && (o.delayed = !1), o.pauseQueue.delete(d), o.timeouts.delete(p), t <= (o.cancelId || 0) && (f = !0);
      try {
        s.start({
          ...n,
          callId: t,
          cancel: f
        }, i);
      } catch (c) {
        a(c);
      }
    }
  });
}
import { is as je, raf as cn, flush as fn, eachProp as dn, Globals as Pt } from "@react-spring/shared";
var be = (t, e) => e.length == 1 ? e[0] : e.some(n => n.cancelled) ? q(t.get()) : e.every(n => n.noop) ? nt(t.get()) : E(t.get(), e.every(n => n.finished)),
  nt = t => ({
    value: t,
    noop: !0,
    finished: !0,
    cancelled: !1
  }),
  E = function (t, e) {
    let n = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : !1;
    return {
      value: t,
      finished: e,
      cancelled: n
    };
  },
  q = t => ({
    value: t,
    cancelled: !0,
    finished: !1
  });
function De(t, e, n, r) {
  let {
      callId: o,
      parentId: s,
      onRest: i
    } = e,
    {
      asyncTo: a,
      promise: u
    } = n;
  return !s && t === a && !e.reset ? u : n.promise = (async () => {
    n.asyncId = o, n.asyncTo = t;
    let p = ne(e, (l, h) => h === "onRest" ? void 0 : l),
      f,
      d,
      m = new Promise((l, h) => (f = l, d = h)),
      b = l => {
        let h = o <= (n.cancelId || 0) && q(r) || o !== n.asyncId && E(r, !1);
        if (h) throw l.result = h, d(l), l;
      },
      c = (l, h) => {
        let g = new Ae(),
          x = new Ne();
        return (async () => {
          if (Pt.skipAnimation) throw oe(n), x.result = E(r, !1), d(x), x;
          b(g);
          let S = je.obj(l) ? {
            ...l
          } : {
            ...h,
            to: l
          };
          S.parentId = o, dn(p, (V, _) => {
            je.und(S[_]) && (S[_] = V);
          });
          let A = await r.start(S);
          return b(g), n.paused && (await new Promise(V => {
            n.resumeQueue.add(V);
          })), A;
        })();
      },
      P;
    if (Pt.skipAnimation) return oe(n), E(r, !1);
    try {
      let l;
      je.arr(t) ? l = (async h => {
        for (let g of h) await c(g);
      })(t) : l = Promise.resolve(t(c, r.stop.bind(r))), await Promise.all([l.then(f), m]), P = E(r.get(), !0, !1);
    } catch (l) {
      if (l instanceof Ae) P = l.result;else if (l instanceof Ne) P = l.result;else throw l;
    } finally {
      o == n.asyncId && (n.asyncId = s, n.asyncTo = s ? a : void 0, n.promise = s ? u : void 0);
    }
    return je.fun(i) && cn.batchedUpdates(() => {
      i(P, r, r.item);
    }), P;
  })();
}
function oe(t, e) {
  fn(t.timeouts, n => n.cancel()), t.pauseQueue.clear(), t.resumeQueue.clear(), t.asyncId = t.asyncTo = t.promise = void 0, e && (t.cancelId = e);
}
var Ae = class extends Error {
    result;
    constructor() {
      super("An async animation has been interrupted. You see this error because you forgot to use `await` or `.catch(...)` on its returned promise.");
    }
  },
  Ne = class extends Error {
    result;
    constructor() {
      super("SkipAnimationSignal");
    }
  };
import { deprecateInterpolate as mn, frameLoop as hn, FluidValue as gn, Globals as Tt, callFluidObservers as xt } from "@react-spring/shared";
import { getAnimated as yn } from "@react-spring/animated";
var Re = t => t instanceof X,
  Sn = 1,
  X = class extends gn {
    id = Sn++;
    _priority = 0;
    get priority() {
      return this._priority;
    }
    set priority(e) {
      this._priority != e && (this._priority = e, this._onPriorityChange(e));
    }
    get() {
      let e = yn(this);
      return e && e.getValue();
    }
    to() {
      for (var _len2 = arguments.length, e = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
        e[_key2] = arguments[_key2];
      }
      return Tt.to(this, e);
    }
    interpolate() {
      for (var _len3 = arguments.length, e = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
        e[_key3] = arguments[_key3];
      }
      return mn(), Tt.to(this, e);
    }
    toJSON() {
      return this.get();
    }
    observerAdded(e) {
      e == 1 && this._attach();
    }
    observerRemoved(e) {
      e == 0 && this._detach();
    }
    _attach() {}
    _detach() {}
    _onChange(e) {
      let n = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : !1;
      xt(this, {
        type: "change",
        parent: this,
        value: e,
        idle: n
      });
    }
    _onPriorityChange(e) {
      this.idle || hn.sort(this), xt(this, {
        type: "priority",
        parent: this,
        priority: e
      });
    }
  };
var se = Symbol.for("SpringPhase"),
  bt = 1,
  rt = 2,
  ot = 4,
  qe = t => (t[se] & bt) > 0,
  Q = t => (t[se] & rt) > 0,
  ye = t => (t[se] & ot) > 0,
  st = (t, e) => e ? t[se] |= rt | bt : t[se] &= ~rt,
  it = (t, e) => e ? t[se] |= ot : t[se] &= ~ot;
var ue = class extends X {
  key;
  animation = new Le();
  queue;
  defaultProps = {};
  _state = {
    paused: !1,
    delayed: !1,
    pauseQueue: new Set(),
    resumeQueue: new Set(),
    timeouts: new Set()
  };
  _pendingCalls = new Set();
  _lastCallId = 0;
  _lastToId = 0;
  _memoizedDuration = 0;
  constructor(e, n) {
    if (super(), !R.und(e) || !R.und(n)) {
      let r = R.obj(e) ? {
        ...e
      } : {
        ...n,
        from: e
      };
      R.und(r.default) && (r.default = !0), this.start(r);
    }
  }
  get idle() {
    return !(Q(this) || this._state.asyncTo) || ye(this);
  }
  get goal() {
    return ie(this.animation.to);
  }
  get velocity() {
    let e = ae(this);
    return e instanceof Cn ? e.lastVelocity || 0 : e.getPayload().map(n => n.lastVelocity || 0);
  }
  get hasAnimated() {
    return qe(this);
  }
  get isAnimating() {
    return Q(this);
  }
  get isPaused() {
    return ye(this);
  }
  get isDelayed() {
    return this._state.delayed;
  }
  advance(e) {
    let n = !0,
      r = !1,
      o = this.animation,
      {
        toValues: s
      } = o,
      {
        config: i
      } = o,
      a = In(o.to);
    !a && Se(o.to) && (s = Rt(ie(o.to))), o.values.forEach((f, d) => {
      if (f.done) return;
      let m = f.constructor == Ct ? 1 : a ? a[d].lastPosition : s[d],
        b = o.immediate,
        c = m;
      if (!b) {
        if (c = f.lastPosition, i.tension <= 0) {
          f.done = !0;
          return;
        }
        let P = f.elapsedTime += e,
          l = o.fromValues[d],
          h = f.v0 != null ? f.v0 : f.v0 = R.arr(i.velocity) ? i.velocity[d] : i.velocity,
          g,
          x = i.precision || (l == m ? .005 : Math.min(1, Math.abs(m - l) * .001));
        if (R.und(i.duration)) {
          if (i.decay) {
            let S = i.decay === !0 ? .998 : i.decay,
              A = Math.exp(-(1 - S) * P);
            c = l + h / (1 - S) * (1 - A), b = Math.abs(f.lastPosition - c) <= x, g = h * A;
          } else {
            g = f.lastVelocity == null ? h : f.lastVelocity;
            let S = i.restVelocity || x / 10,
              A = i.clamp ? 0 : i.bounce,
              V = !R.und(A),
              _ = l == m ? f.v0 > 0 : l < m,
              v,
              w = !1,
              C = 1,
              $ = Math.ceil(e / C);
            for (let L = 0; L < $ && (v = Math.abs(g) > S, !(!v && (b = Math.abs(m - c) <= x, b))); ++L) {
              V && (w = c == m || c > m == _, w && (g = -g * A, c = m));
              let N = -i.tension * 1e-6 * (c - m),
                y = -i.friction * .001 * g,
                T = (N + y) / i.mass;
              g = g + T * C, c = c + g * C;
            }
          }
        } else {
          let S = 1;
          i.duration > 0 && (this._memoizedDuration !== i.duration && (this._memoizedDuration = i.duration, f.durationProgress > 0 && (f.elapsedTime = i.duration * f.durationProgress, P = f.elapsedTime += e)), S = (i.progress || 0) + P / this._memoizedDuration, S = S > 1 ? 1 : S < 0 ? 0 : S, f.durationProgress = S), c = l + i.easing(S) * (m - l), g = (c - f.lastPosition) / e, b = S == 1;
        }
        f.lastVelocity = g, Number.isNaN(c) && (console.warn("Got NaN while animating:", this), b = !0);
      }
      a && !a[d].done && (b = !1), b ? f.done = !0 : n = !1, f.setValue(c, i.round) && (r = !0);
    });
    let u = ae(this),
      p = u.getValue();
    if (n) {
      let f = ie(o.to);
      (p !== f || r) && !i.decay ? (u.setValue(f), this._onChange(f)) : r && i.decay && this._onChange(p), this._stop();
    } else r && this._onChange(p);
  }
  set(e) {
    return ve.batchedUpdates(() => {
      this._stop(), this._focus(e), this._set(e);
    }), this;
  }
  pause() {
    this._update({
      pause: !0
    });
  }
  resume() {
    this._update({
      pause: !1
    });
  }
  finish() {
    if (Q(this)) {
      let {
        to: e,
        config: n
      } = this.animation;
      ve.batchedUpdates(() => {
        this._onStart(), n.decay || this._set(e, !1), this._stop();
      });
    }
    return this;
  }
  update(e) {
    return (this.queue || (this.queue = [])).push(e), this;
  }
  start(e, n) {
    let r;
    return R.und(e) ? (r = this.queue || [], this.queue = []) : r = [R.obj(e) ? e : {
      ...n,
      to: e
    }], Promise.all(r.map(o => this._update(o))).then(o => be(this, o));
  }
  stop(e) {
    let {
      to: n
    } = this.animation;
    return this._focus(this.get()), oe(this._state, e && this._lastCallId), ve.batchedUpdates(() => this._stop(n, e)), this;
  }
  reset() {
    this._update({
      reset: !0
    });
  }
  eventObserved(e) {
    e.type == "change" ? this._start() : e.type == "priority" && (this.priority = e.priority + 1);
  }
  _prepareNode(e) {
    let n = this.key || "",
      {
        to: r,
        from: o
      } = e;
    r = R.obj(r) ? r[n] : r, (r == null || Ee(r)) && (r = void 0), o = R.obj(o) ? o[n] : o, o == null && (o = void 0);
    let s = {
      to: r,
      from: o
    };
    return qe(this) || (e.reverse && ([r, o] = [o, r]), o = ie(o), R.und(o) ? ae(this) || this._set(r) : this._set(o)), s;
  }
  _update(_ref2, n) {
    let {
      ...e
    } = _ref2;
    let {
      key: r,
      defaultProps: o
    } = this;
    e.default && Object.assign(o, ne(e, (a, u) => /^on/.test(u) ? et(a, r) : a)), _t(this, e, "onProps"), Ie(this, "onProps", e, this);
    let s = this._prepareNode(e);
    if (Object.isFrozen(this)) throw Error("Cannot animate a `SpringValue` object that is frozen. Did you forget to pass your component to `animated(...)` before animating its props?");
    let i = this._state;
    return Me(++this._lastCallId, {
      key: r,
      props: e,
      defaultProps: o,
      state: i,
      actions: {
        pause: () => {
          ye(this) || (it(this, !0), Qe(i.pauseQueue), Ie(this, "onPause", E(this, Ce(this, this.animation.to)), this));
        },
        resume: () => {
          ye(this) && (it(this, !1), Q(this) && this._resume(), Qe(i.resumeQueue), Ie(this, "onResume", E(this, Ce(this, this.animation.to)), this));
        },
        start: this._merge.bind(this, s)
      }
    }).then(a => {
      if (e.loop && a.finished && !(n && a.noop)) {
        let u = at(e);
        if (u) return this._update(u, !0);
      }
      return a;
    });
  }
  _merge(e, n, r) {
    if (n.cancel) return this.stop(!0), r(q(this));
    let o = !R.und(e.to),
      s = !R.und(e.from);
    if (o || s) if (n.callId > this._lastToId) this._lastToId = n.callId;else return r(q(this));
    let {
        key: i,
        defaultProps: a,
        animation: u
      } = this,
      {
        to: p,
        from: f
      } = u,
      {
        to: d = p,
        from: m = f
      } = e;
    s && !o && (!n.default || R.und(d)) && (d = m), n.reverse && ([d, m] = [m, d]);
    let b = !Y(m, f);
    b && (u.from = m), m = ie(m);
    let c = !Y(d, p);
    c && this._focus(d);
    let P = Ee(n.to),
      {
        config: l
      } = u,
      {
        decay: h,
        velocity: g
      } = l;
    (o || s) && (l.velocity = 0), n.config && !P && gt(l, I(n.config, i), n.config !== a.config ? I(a.config, i) : void 0);
    let x = ae(this);
    if (!x || R.und(d)) return r(E(this, !0));
    let S = R.und(n.reset) ? s && !n.default : !R.und(m) && te(n.reset, i),
      A = S ? m : this.get(),
      V = me(d),
      _ = R.num(V) || R.arr(V) || xn(V),
      v = !P && (!_ || te(a.immediate || n.immediate, i));
    if (c) {
      let L = It(d);
      if (L !== x.constructor) if (v) x = this._set(V);else throw Error(`Cannot animate between ${x.constructor.name} and ${L.name}, as the "to" prop suggests`);
    }
    let w = x.constructor,
      C = Se(d),
      $ = !1;
    if (!C) {
      let L = S || !qe(this) && b;
      (c || L) && ($ = Y(me(A), V), C = !$), (!Y(u.immediate, v) && !v || !Y(l.decay, h) || !Y(l.velocity, g)) && (C = !0);
    }
    if ($ && Q(this) && (u.changed && !S ? C = !0 : C || this._stop(p)), !P && ((C || Se(p)) && (u.values = x.getPayload(), u.toValues = Se(d) ? null : w == Ct ? [1] : Rt(V)), u.immediate != v && (u.immediate = v, !v && !S && this._set(p)), C)) {
      let {
        onRest: L
      } = u;
      At(_n, y => _t(this, n, y));
      let N = E(this, Ce(this, p));
      Qe(this._pendingCalls, N), this._pendingCalls.add(r), u.changed && ve.batchedUpdates(() => {
        u.changed = !S, L?.(N, this), S ? I(a.onRest, N) : u.onStart?.(N, this);
      });
    }
    S && this._set(A), P ? r(De(n.to, n, this._state, this)) : C ? this._start() : Q(this) && !c ? this._pendingCalls.add(r) : r(nt(A));
  }
  _focus(e) {
    let n = this.animation;
    e !== n.to && (vt(this) && this._detach(), n.to = e, vt(this) && this._attach());
  }
  _attach() {
    let e = 0,
      {
        to: n
      } = this.animation;
    Se(n) && (Rn(n, this), Re(n) && (e = n.priority + 1)), this.priority = e;
  }
  _detach() {
    let {
      to: e
    } = this.animation;
    Se(e) && vn(e, this);
  }
  _set(e) {
    let n = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : !0;
    let r = ie(e);
    if (!R.und(r)) {
      let o = ae(this);
      if (!o || !Y(r, o.getValue())) {
        let s = It(r);
        !o || o.constructor != s ? Vn(this, s.create(r)) : o.setValue(r), o && ve.batchedUpdates(() => {
          this._onChange(r, n);
        });
      }
    }
    return ae(this);
  }
  _onStart() {
    let e = this.animation;
    e.changed || (e.changed = !0, Ie(this, "onStart", E(this, Ce(this, e.to)), this));
  }
  _onChange(e, n) {
    n || (this._onStart(), I(this.animation.onChange, e, this)), I(this.defaultProps.onChange, e, this), super._onChange(e, n);
  }
  _start() {
    let e = this.animation;
    ae(this).reset(ie(e.to)), e.immediate || (e.fromValues = e.values.map(n => n.lastPosition)), Q(this) || (st(this, !0), ye(this) || this._resume());
  }
  _resume() {
    bn.skipAnimation ? this.finish() : Tn.start(this);
  }
  _stop(e, n) {
    if (Q(this)) {
      st(this, !1);
      let r = this.animation;
      At(r.values, s => {
        s.done = !0;
      }), r.toValues && (r.onChange = r.onPause = r.onResume = void 0), An(this, {
        type: "idle",
        parent: this
      });
      let o = n ? q(this.get()) : E(this.get(), Ce(this, e ?? r.to));
      Qe(this._pendingCalls, o), r.changed && (r.changed = !1, Ie(this, "onRest", o, this));
    }
  }
};
function Ce(t, e) {
  let n = me(e),
    r = me(t.get());
  return Y(r, n);
}
function at(t) {
  let e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : t.loop;
  let n = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : t.to;
  let r = I(e);
  if (r) {
    let o = r !== !0 && de(r),
      s = (o || t).reverse,
      i = !o || o.reset;
    return Pe({
      ...t,
      loop: e,
      default: !1,
      pause: void 0,
      to: !s || Ee(n) ? n : void 0,
      from: i ? t.from : void 0,
      reset: i,
      ...o
    });
  }
}
function Pe(t) {
  let {
      to: e,
      from: n
    } = t = de(t),
    r = new Set();
  return R.obj(e) && Vt(e, r), R.obj(n) && Vt(n, r), t.keys = r.size ? Array.from(r) : null, t;
}
function Ot(t) {
  let e = Pe(t);
  return R.und(e.default) && (e.default = ne(e)), e;
}
function Vt(t, e) {
  Pn(t, (n, r) => n != null && e.add(r));
}
var _n = ["onStart", "onRest", "onChange", "onPause", "onResume"];
function _t(t, e, n) {
  t.animation[n] = e[n] !== ke(e, n) ? et(e[n], t.key) : void 0;
}
function Ie(t, e) {
  for (var _len4 = arguments.length, n = new Array(_len4 > 2 ? _len4 - 2 : 0), _key4 = 2; _key4 < _len4; _key4++) {
    n[_key4 - 2] = arguments[_key4];
  }
  t.animation[e]?.(...n), t.defaultProps[e]?.(...n);
}
import { is as z, raf as kt, each as pe, noop as Ft, flush as ut, toArray as Ve, eachProp as Ut, flushCalls as On, addFluidObserver as Et } from "@react-spring/shared";
var Fn = ["onStart", "onChange", "onRest"],
  kn = 1,
  le = class {
    id = kn++;
    springs = {};
    queue = [];
    ref;
    _flush;
    _initialProps;
    _lastAsyncId = 0;
    _active = new Set();
    _changed = new Set();
    _started = !1;
    _item;
    _state = {
      paused: !1,
      pauseQueue: new Set(),
      resumeQueue: new Set(),
      timeouts: new Set()
    };
    _events = {
      onStart: new Map(),
      onChange: new Map(),
      onRest: new Map()
    };
    constructor(e, n) {
      this._onFrame = this._onFrame.bind(this), n && (this._flush = n), e && this.start({
        default: !0,
        ...e
      });
    }
    get idle() {
      return !this._state.asyncTo && Object.values(this.springs).every(e => e.idle && !e.isDelayed && !e.isPaused);
    }
    get item() {
      return this._item;
    }
    set item(e) {
      this._item = e;
    }
    get() {
      let e = {};
      return this.each((n, r) => e[r] = n.get()), e;
    }
    set(e) {
      for (let n in e) {
        let r = e[n];
        z.und(r) || this.springs[n].set(r);
      }
    }
    update(e) {
      return e && this.queue.push(Pe(e)), this;
    }
    start(e) {
      let {
        queue: n
      } = this;
      return e ? n = Ve(e).map(Pe) : this.queue = [], this._flush ? this._flush(this, n) : (jt(this, n), ze(this, n));
    }
    stop(e, n) {
      if (e !== !!e && (n = e), n) {
        let r = this.springs;
        pe(Ve(n), o => r[o].stop(!!e));
      } else oe(this._state, this._lastAsyncId), this.each(r => r.stop(!!e));
      return this;
    }
    pause(e) {
      if (z.und(e)) this.start({
        pause: !0
      });else {
        let n = this.springs;
        pe(Ve(e), r => n[r].pause());
      }
      return this;
    }
    resume(e) {
      if (z.und(e)) this.start({
        pause: !1
      });else {
        let n = this.springs;
        pe(Ve(e), r => n[r].resume());
      }
      return this;
    }
    each(e) {
      Ut(this.springs, e);
    }
    _onFrame() {
      let {
          onStart: e,
          onChange: n,
          onRest: r
        } = this._events,
        o = this._active.size > 0,
        s = this._changed.size > 0;
      (o && !this._started || s && !this._started) && (this._started = !0, ut(e, _ref3 => {
        let [u, p] = _ref3;
        p.value = this.get(), u(p, this, this._item);
      }));
      let i = !o && this._started,
        a = s || i && r.size ? this.get() : null;
      s && n.size && ut(n, _ref4 => {
        let [u, p] = _ref4;
        p.value = a, u(p, this, this._item);
      }), i && (this._started = !1, ut(r, _ref5 => {
        let [u, p] = _ref5;
        p.value = a, u(p, this, this._item);
      }));
    }
    eventObserved(e) {
      if (e.type == "change") this._changed.add(e.parent), e.idle || this._active.add(e.parent);else if (e.type == "idle") this._active.delete(e.parent);else return;
      kt.onFrame(this._onFrame);
    }
  };
function ze(t, e) {
  return Promise.all(e.map(n => wt(t, n))).then(n => be(t, n));
}
async function wt(t, e, n) {
  let {
      keys: r,
      to: o,
      from: s,
      loop: i,
      onRest: a,
      onResolve: u
    } = e,
    p = z.obj(e.default) && e.default;
  i && (e.loop = !1), o === !1 && (e.to = null), s === !1 && (e.from = null);
  let f = z.arr(o) || z.fun(o) ? o : void 0;
  f ? (e.to = void 0, e.onRest = void 0, p && (p.onRest = void 0)) : pe(Fn, P => {
    let l = e[P];
    if (z.fun(l)) {
      let h = t._events[P];
      e[P] = _ref6 => {
        let {
          finished: g,
          cancelled: x
        } = _ref6;
        let S = h.get(l);
        S ? (g || (S.finished = !1), x && (S.cancelled = !0)) : h.set(l, {
          value: null,
          finished: g || !1,
          cancelled: x || !1
        });
      }, p && (p[P] = e[P]);
    }
  });
  let d = t._state;
  e.pause === !d.paused ? (d.paused = e.pause, On(e.pause ? d.pauseQueue : d.resumeQueue)) : d.paused && (e.pause = !0);
  let m = (r || Object.keys(t.springs)).map(P => t.springs[P].start(e)),
    b = e.cancel === !0 || ke(e, "cancel") === !0;
  (f || b && d.asyncId) && m.push(Me(++t._lastAsyncId, {
    props: e,
    state: d,
    actions: {
      pause: Ft,
      resume: Ft,
      start(P, l) {
        b ? (oe(d, t._lastAsyncId), l(q(t))) : (P.onRest = a, l(De(f, P, d, t)));
      }
    }
  })), d.paused && (await new Promise(P => {
    d.resumeQueue.add(P);
  }));
  let c = be(t, await Promise.all(m));
  if (i && c.finished && !(n && c.noop)) {
    let P = at(e, i, o);
    if (P) return jt(t, [P]), wt(t, P, !0);
  }
  return u && kt.batchedUpdates(() => u(c, t, t.item)), c;
}
function _e(t, e) {
  let n = {
    ...t.springs
  };
  return e && pe(Ve(e), r => {
    z.und(r.keys) && (r = Pe(r)), z.obj(r.to) || (r = {
      ...r,
      to: void 0
    }), Mt(n, r, o => Lt(o));
  }), pt(t, n), n;
}
function pt(t, e) {
  Ut(e, (n, r) => {
    t.springs[r] || (t.springs[r] = n, Et(n, t));
  });
}
function Lt(t, e) {
  let n = new ue();
  return n.key = t, e && Et(n, e), n;
}
function Mt(t, e, n) {
  e.keys && pe(e.keys, r => {
    (t[r] || (t[r] = n(r)))._prepareNode(e);
  });
}
function jt(t, e) {
  pe(e, n => {
    Mt(t.springs, n, r => Lt(r, t));
  });
}
import * as Be from "react";
import { useContext as Un } from "react";
import { useMemoOne as En } from "@react-spring/shared";
var H = _ref7 => {
    let {
      children: t,
      ...e
    } = _ref7;
    let n = Un(Ge),
      r = e.pause || !!n.pause,
      o = e.immediate || !!n.immediate;
    e = En(() => ({
      pause: r,
      immediate: o
    }), [r, o]);
    let {
      Provider: s
    } = Ge;
    return Be.createElement(s, {
      value: e
    }, t);
  },
  Ge = wn(H, {});
H.Provider = Ge.Provider;
H.Consumer = Ge.Consumer;
function wn(t, e) {
  return Object.assign(t, Be.createContext(e)), t.Provider._context = t, t.Consumer._context = t, t;
}
import { each as ce, is as Ke, deprecateDirectCall as Ln } from "@react-spring/shared";
var fe = () => {
  let t = [],
    e = function (r) {
      Ln();
      let o = [];
      return ce(t, (s, i) => {
        if (Ke.und(r)) o.push(s.start());else {
          let a = n(r, s, i);
          a && o.push(s.start(a));
        }
      }), o;
    };
  e.current = t, e.add = function (r) {
    t.includes(r) || t.push(r);
  }, e.delete = function (r) {
    let o = t.indexOf(r);
    ~o && t.splice(o, 1);
  }, e.pause = function () {
    return ce(t, r => r.pause(...arguments)), this;
  }, e.resume = function () {
    return ce(t, r => r.resume(...arguments)), this;
  }, e.set = function (r) {
    ce(t, (o, s) => {
      let i = Ke.fun(r) ? r(s, o) : r;
      i && o.set(i);
    });
  }, e.start = function (r) {
    let o = [];
    return ce(t, (s, i) => {
      if (Ke.und(r)) o.push(s.start());else {
        let a = this._getProps(r, s, i);
        a && o.push(s.start(a));
      }
    }), o;
  }, e.stop = function () {
    return ce(t, r => r.stop(...arguments)), this;
  }, e.update = function (r) {
    return ce(t, (o, s) => o.update(this._getProps(r, o, s))), this;
  };
  let n = function (r, o, s) {
    return Ke.fun(r) ? r(s, o) : r;
  };
  return e._getProps = n, e;
};
function He(t, e, n) {
  let r = jn.fun(e) && e;
  r && !n && (n = []);
  let o = Xe(() => r || arguments.length == 3 ? fe() : void 0, []),
    s = Nt(0),
    i = Dn(),
    a = Xe(() => ({
      ctrls: [],
      queue: [],
      flush(h, g) {
        let x = _e(h, g);
        return s.current > 0 && !a.queue.length && !Object.keys(x).some(A => !h.springs[A]) ? ze(h, g) : new Promise(A => {
          pt(h, x), a.queue.push(() => {
            A(ze(h, g));
          }), i();
        });
      }
    }), []),
    u = Nt([...a.ctrls]),
    p = [],
    f = Dt(t) || 0;
  Xe(() => {
    Ye(u.current.slice(t, f), h => {
      xe(h, o), h.stop(!0);
    }), u.current.length = t, d(f, t);
  }, [t]), Xe(() => {
    d(0, Math.min(f, t));
  }, n);
  function d(h, g) {
    for (let x = h; x < g; x++) {
      let S = u.current[x] || (u.current[x] = new le(null, a.flush)),
        A = r ? r(x, S) : e[x];
      A && (p[x] = Ot(A));
    }
  }
  let m = u.current.map((h, g) => _e(h, p[g])),
    b = Mn(H),
    c = Dt(b),
    P = b !== c && Ue(b);
  qn(() => {
    s.current++, a.ctrls = u.current;
    let {
      queue: h
    } = a;
    h.length && (a.queue = [], Ye(h, g => g())), Ye(u.current, (g, x) => {
      o?.add(g), P && g.start({
        default: b
      });
      let S = p[x];
      S && (he(g, S.ref), g.ref ? g.queue.push(S) : g.start(S));
    });
  }), Nn(() => () => {
    Ye(a.ctrls, h => h.stop(!0));
  });
  let l = m.map(h => ({
    ...h
  }));
  return o ? [l, o] : l;
}
function J(t, e) {
  let n = Qn.fun(t),
    [[r], o] = He(1, n ? t : [t], n ? e || [] : e);
  return n || arguments.length == 2 ? [r, o] : r;
}
import { useState as zn } from "react";
var Gn = () => fe(),
  Xo = () => zn(Gn)[0];
import { useConstant as Bn, useOnce as Kn } from "@react-spring/shared";
var Wo = (t, e) => {
  let n = Bn(() => new ue(t, e));
  return Kn(() => () => {
    n.stop();
  }), n;
};
import { each as Xn, is as qt, useIsomorphicLayoutEffect as Yn } from "@react-spring/shared";
function Qt(t, e, n) {
  let r = qt.fun(e) && e;
  r && !n && (n = []);
  let o = !0,
    s,
    i = He(t, (a, u) => {
      let p = r ? r(a, u) : e;
      return s = p.ref, o = o && p.reverse, p;
    }, n || [{}]);
  if (Yn(() => {
    Xn(i[1].current, (a, u) => {
      let p = i[1].current[u + (o ? 1 : -1)];
      if (he(a, s), a.ref) {
        p && a.update({
          to: p.springs
        });
        return;
      }
      p ? a.start({
        to: p.springs
      }) : a.start();
    });
  }, n), r || arguments.length == 3) {
    let a = s ?? i[1];
    return a._getProps = (u, p, f) => {
      let d = qt.fun(u) ? u(f, p) : u;
      if (d) {
        let m = a.current[f + (d.reverse ? 1 : -1)];
        return m && (d.to = m.springs), d;
      }
    }, i;
  }
  return i[0];
}
import * as Oe from "react";
import { useContext as Hn, useRef as lt, useMemo as Jn } from "react";
import { is as G, toArray as zt, useForceUpdate as Wn, useOnce as $n, usePrev as Zn, each as j, useIsomorphicLayoutEffect as Je } from "@react-spring/shared";
function Gt(t, e, n) {
  let r = G.fun(e) && e,
    {
      reset: o,
      sort: s,
      trail: i = 0,
      expires: a = !0,
      exitBeforeEnter: u = !1,
      onDestroyed: p,
      ref: f,
      config: d
    } = r ? r() : e,
    m = Jn(() => r || arguments.length == 3 ? fe() : void 0, []),
    b = zt(t),
    c = [],
    P = lt(null),
    l = o ? null : P.current;
  Je(() => {
    P.current = c;
  }), $n(() => (j(c, y => {
    m?.add(y.ctrl), y.ctrl.ref = m;
  }), () => {
    j(P.current, y => {
      y.expired && clearTimeout(y.expirationId), xe(y.ctrl, m), y.ctrl.stop(!0);
    });
  }));
  let h = tr(b, r ? r() : e, l),
    g = o && P.current || [];
  Je(() => j(g, _ref8 => {
    let {
      ctrl: y,
      item: T,
      key: F
    } = _ref8;
    xe(y, m), I(p, T, F);
  }));
  let x = [];
  if (l && j(l, (y, T) => {
    y.expired ? (clearTimeout(y.expirationId), g.push(y)) : (T = x[T] = h.indexOf(y.key), ~T && (c[T] = y));
  }), j(b, (y, T) => {
    c[T] || (c[T] = {
      key: h[T],
      item: y,
      phase: "mount",
      ctrl: new le()
    }, c[T].ctrl.item = y);
  }), x.length) {
    let y = -1,
      {
        leave: T
      } = r ? r() : e;
    j(x, (F, k) => {
      let O = l[k];
      ~F ? (y = c.indexOf(O), c[y] = {
        ...O,
        item: b[F]
      }) : T && c.splice(++y, 0, O);
    });
  }
  G.fun(s) && c.sort((y, T) => s(y.item, T.item));
  let S = -i,
    A = Wn(),
    V = ne(e),
    _ = new Map(),
    v = lt(new Map()),
    w = lt(!1);
  j(c, (y, T) => {
    let F = y.key,
      k = y.phase,
      O = r ? r() : e,
      U,
      D,
      Jt = I(O.delay || 0, F);
    if (k == "mount") U = O.enter, D = "enter";else {
      let M = h.indexOf(F) < 0;
      if (k != "leave") {
        if (M) U = O.leave, D = "leave";else if (U = O.update) D = "update";else return;
      } else if (!M) U = O.enter, D = "enter";else return;
    }
    if (U = I(U, y.item, T), U = G.obj(U) ? de(U) : {
      to: U
    }, !U.config) {
      let M = d || V.config;
      U.config = I(M, y.item, T, D);
    }
    S += i;
    let Z = {
      ...V,
      delay: Jt + S,
      ref: f,
      immediate: O.immediate,
      reset: !1,
      ...U
    };
    if (D == "enter" && G.und(Z.from)) {
      let M = r ? r() : e,
        Te = G.und(M.initial) || l ? M.from : M.initial;
      Z.from = I(Te, y.item, T);
    }
    let {
      onResolve: Wt
    } = Z;
    Z.onResolve = M => {
      I(Wt, M);
      let Te = P.current,
        B = Te.find(Fe => Fe.key === F);
      if (B && !(M.cancelled && B.phase != "update") && B.ctrl.idle) {
        let Fe = Te.every(ee => ee.ctrl.idle);
        if (B.phase == "leave") {
          let ee = I(a, B.item);
          if (ee !== !1) {
            let Ze = ee === !0 ? 0 : ee;
            if (B.expired = !0, !Fe && Ze > 0) {
              Ze <= 2147483647 && (B.expirationId = setTimeout(A, Ze));
              return;
            }
          }
        }
        Fe && Te.some(ee => ee.expired) && (v.current.delete(B), u && (w.current = !0), A());
      }
    };
    let ft = _e(y.ctrl, Z);
    D === "leave" && u ? v.current.set(y, {
      phase: D,
      springs: ft,
      payload: Z
    }) : _.set(y, {
      phase: D,
      springs: ft,
      payload: Z
    });
  });
  let C = Hn(H),
    $ = Zn(C),
    L = C !== $ && Ue(C);
  Je(() => {
    L && j(c, y => {
      y.ctrl.start({
        default: C
      });
    });
  }, [C]), j(_, (y, T) => {
    if (v.current.size) {
      let F = c.findIndex(k => k.key === T.key);
      c.splice(F, 1);
    }
  }), Je(() => {
    j(v.current.size ? v.current : _, (_ref9, F) => {
      let {
        phase: y,
        payload: T
      } = _ref9;
      let {
        ctrl: k
      } = F;
      F.phase = y, m?.add(k), L && y == "enter" && k.start({
        default: C
      }), T && (he(k, T.ref), (k.ref || m) && !w.current ? k.update(T) : (k.start(T), w.current && (w.current = !1)));
    });
  }, o ? void 0 : n);
  let N = y => Oe.createElement(Oe.Fragment, null, c.map((T, F) => {
    let {
        springs: k
      } = _.get(T) || T.ctrl,
      O = y({
        ...k
      }, T.item, T, F);
    return O && O.type ? Oe.createElement(O.type, {
      ...O.props,
      key: G.str(T.key) || G.num(T.key) ? T.key : T.ctrl.id,
      ref: O.ref
    }) : O;
  }));
  return m ? [N, m] : N;
}
var er = 1;
function tr(t, _ref10, r) {
  let {
    key: e,
    keys: n = e
  } = _ref10;
  if (n === null) {
    let o = new Set();
    return t.map(s => {
      let i = r && r.find(a => a.item === s && a.phase !== "leave" && !o.has(a));
      return i ? (o.add(i), i.key) : er++;
    });
  }
  return G.und(n) ? t : G.fun(n) ? t.map(n) : zt(n);
}
import { each as nr, onScroll as rr, useIsomorphicLayoutEffect as or } from "@react-spring/shared";
var hs = function () {
  let {
    container: t,
    ...e
  } = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  let [n, r] = J(() => ({
    scrollX: 0,
    scrollY: 0,
    scrollXProgress: 0,
    scrollYProgress: 0,
    ...e
  }), []);
  return or(() => {
    let o = rr(_ref11 => {
      let {
        x: s,
        y: i
      } = _ref11;
      r.start({
        scrollX: s.current,
        scrollXProgress: s.progress,
        scrollY: i.current,
        scrollYProgress: i.progress
      });
    }, {
      container: t?.current || void 0
    });
    return () => {
      nr(Object.values(n), s => s.stop()), o();
    };
  }, []), n;
};
import { onResize as sr, each as ir, useIsomorphicLayoutEffect as ar } from "@react-spring/shared";
var Ps = _ref12 => {
  let {
    container: t,
    ...e
  } = _ref12;
  let [n, r] = J(() => ({
    width: 0,
    height: 0,
    ...e
  }), []);
  return ar(() => {
    let o = sr(_ref13 => {
      let {
        width: s,
        height: i
      } = _ref13;
      r.start({
        width: s,
        height: i,
        immediate: n.width.get() === 0 || n.height.get() === 0
      });
    }, {
      container: t?.current || void 0
    });
    return () => {
      ir(Object.values(n), s => s.stop()), o();
    };
  }, []), n;
};
import { useRef as ur, useState as pr } from "react";
import { is as Bt, useIsomorphicLayoutEffect as lr } from "@react-spring/shared";
var cr = {
  any: 0,
  all: 1
};
function Cs(t, e) {
  let [n, r] = pr(!1),
    o = ur(),
    s = Bt.fun(t) && t,
    i = s ? s() : {},
    {
      to: a = {},
      from: u = {},
      ...p
    } = i,
    f = s ? e : t,
    [d, m] = J(() => ({
      from: u,
      ...p
    }), []);
  return lr(() => {
    let b = o.current,
      {
        root: c,
        once: P,
        amount: l = "any",
        ...h
      } = f ?? {};
    if (!b || P && n || typeof IntersectionObserver > "u") return;
    let g = new WeakMap(),
      x = () => (a && m.start(a), r(!0), P ? void 0 : () => {
        u && m.start(u), r(!1);
      }),
      S = V => {
        V.forEach(_ => {
          let v = g.get(_.target);
          if (_.isIntersecting !== !!v) if (_.isIntersecting) {
            let w = x();
            Bt.fun(w) ? g.set(_.target, w) : A.unobserve(_.target);
          } else v && (v(), g.delete(_.target));
        });
      },
      A = new IntersectionObserver(S, {
        root: c && c.current || void 0,
        threshold: typeof l == "number" || Array.isArray(l) ? l : cr[l],
        ...h
      });
    return A.observe(b), () => A.unobserve(b);
  }, [f]), s ? [o, d] : [o, n];
}
function qs(_ref14) {
  let {
    children: t,
    ...e
  } = _ref14;
  return t(J(e));
}
import { is as fr } from "@react-spring/shared";
function Bs(_ref15) {
  let {
    items: t,
    children: e,
    ...n
  } = _ref15;
  let r = Qt(t.length, n);
  return t.map((o, s) => {
    let i = e(o, s);
    return fr.fun(i) ? i(r[s]) : i;
  });
}
function Ys(_ref16) {
  let {
    items: t,
    children: e,
    ...n
  } = _ref16;
  return Gt(t, n)(e);
}
import { deprecateInterpolate as Cr } from "@react-spring/shared";
import { is as dr, raf as mr, each as $e, isEqual as hr, toArray as We, frameLoop as gr, getFluidValue as Kt, createInterpolator as yr, Globals as Sr, callFluidObservers as Pr, addFluidObserver as Tr, removeFluidObserver as xr, hasFluidValue as Xt } from "@react-spring/shared";
import { getAnimated as br, setAnimated as Ar, getAnimatedType as Rr, getPayload as Ht } from "@react-spring/animated";
var W = class extends X {
  constructor(n, r) {
    super();
    this.source = n;
    this.calc = yr(...r);
    let o = this._get(),
      s = Rr(o);
    Ar(this, s.create(o));
  }
  key;
  idle = !0;
  calc;
  _active = new Set();
  advance(n) {
    let r = this._get(),
      o = this.get();
    hr(r, o) || (br(this).setValue(r), this._onChange(r, this.idle)), !this.idle && Yt(this._active) && ct(this);
  }
  _get() {
    let n = dr.arr(this.source) ? this.source.map(Kt) : We(Kt(this.source));
    return this.calc(...n);
  }
  _start() {
    this.idle && !Yt(this._active) && (this.idle = !1, $e(Ht(this), n => {
      n.done = !1;
    }), Sr.skipAnimation ? (mr.batchedUpdates(() => this.advance()), ct(this)) : gr.start(this));
  }
  _attach() {
    let n = 1;
    $e(We(this.source), r => {
      Xt(r) && Tr(r, this), Re(r) && (r.idle || this._active.add(r), n = Math.max(n, r.priority + 1));
    }), this.priority = n, this._start();
  }
  _detach() {
    $e(We(this.source), n => {
      Xt(n) && xr(n, this);
    }), this._active.clear(), ct(this);
  }
  eventObserved(n) {
    n.type == "change" ? n.idle ? this.advance() : (this._active.add(n.parent), this._start()) : n.type == "idle" ? this._active.delete(n.parent) : n.type == "priority" && (this.priority = We(this.source).reduce((r, o) => Math.max(r, (Re(o) ? o.priority : 0) + 1), 0));
  }
};
function vr(t) {
  return t.idle !== !1;
}
function Yt(t) {
  return !t.size || Array.from(t).every(vr);
}
function ct(t) {
  t.idle || (t.idle = !0, $e(Ht(t), e => {
    e.done = !0;
  }), Pr(t, {
    type: "idle",
    parent: t
  }));
}
var ui = function (t) {
    for (var _len5 = arguments.length, e = new Array(_len5 > 1 ? _len5 - 1 : 0), _key5 = 1; _key5 < _len5; _key5++) {
      e[_key5 - 1] = arguments[_key5];
    }
    return new W(t, e);
  },
  pi = function (t) {
    for (var _len6 = arguments.length, e = new Array(_len6 > 1 ? _len6 - 1 : 0), _key6 = 1; _key6 < _len6; _key6++) {
      e[_key6 - 1] = arguments[_key6];
    }
    return Cr(), new W(t, e);
  };
import { Globals as Ir, frameLoop as Vr, createStringInterpolator as _r } from "@react-spring/shared";
Ir.assign({
  createStringInterpolator: _r,
  to: (t, e) => new W(t, e)
});
var di = Vr.advance;
import { createInterpolator as Ui, useIsomorphicLayoutEffect as Ei, useReducedMotion as wi, easings as Li } from "@react-spring/shared";
export * from "@react-spring/types";
export { Ae as BailSignal, le as Controller, X as FrameValue, Ir as Globals, W as Interpolation, qs as Spring, H as SpringContext, fe as SpringRef, ue as SpringValue, Bs as Trail, Ys as Transition, mt as config, Ui as createInterpolator, Li as easings, de as inferTo, pi as interpolate, ui as to, di as update, wr as useChain, Cs as useInView, Ei as useIsomorphicLayoutEffect, wi as useReducedMotion, Ps as useResize, hs as useScroll, J as useSpring, Xo as useSpringRef, Wo as useSpringValue, He as useSprings, Qt as useTrail, Gt as useTransition };